export const HOME = {
  emergentLink: "home-emergent-link",
  hero: "home-hero",
};

export const CONTACT = {
  name: "contact-input-name",
  organization: "contact-input-organization",
  country: "contact-input-country",
  email: "contact-input-email",
  message: "contact-input-message",
  submit: "contact-submit-button",
  form: "contact-form",
};
